export const KEY_LABEL_MAP = {
  company_name: "Company Name",
  customer_phone: "Phone",
  customer_email: "Email",
  company_address: "Company Address",
  company_pincode: "Pincode",
  billing_state: "State",
  gst_number: "GST Number",
  hsn_code: "HSN Code",
  gst_percentage: "GST Percentage",
};

export const UPDATE_HISTORY_MODAL_TEXTS = {
  TITLE: "Invoice Update History",
  LOADING: "Loading update history...",
  EMPTY: "No update history available.",
  NO_CHANGES: "No changes recorded.",
  DOWNLOAD_CREDIT_NOTE: "Download Credit Note",
  DOWNLOAD_INVOICE: "Download Invoice",
  DEFAULT_ACTION_LABEL: "Invoice Updated",
};
